import { Navigate } from "react-router-dom";
import CustomerServiceDashboard from "../pages/customerServiceDashboard/customerServiceDashboard";
import CustomerStatusTable from "../pages/customerStatusTable/customerStatusTable";
import Error from "../pages/errorPage/errorPage";
import ApiLoader from "../components/apiLoader/apiLoader";
import Plans from "../pages/admin/plans/plans";
import Devices from "../pages/admin/devices/devices";
import Addons from "../pages/admin/addons/addons";
import CreatePlan from "../pages/admin/CreatePlan/createPlan";
import AddDevice from "../pages/admin/addDevice/addDevice";
import CreateAddons from "../pages/admin/createAddons/createAddons";
import HealthCheckGuard from "../components/heathCheckGuard/heathCheckGuard";

const RedirectHomeElement = () => <Navigate to={"/customer-status"} />;
const RedirectErrorElement = () => <Navigate to={"/page-not-found"} />;

//Add the authenticated pages
export const navItemsPaths = [
  {
    path: "/",
    element: (
      <HealthCheckGuard>
        <RedirectHomeElement />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/customer-service-dashboard/:id`,
    element: (
      <HealthCheckGuard>
        <CustomerServiceDashboard />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/customer-status`,
    element: (
      <HealthCheckGuard>
        <CustomerStatusTable />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/plans`,
    element: (
      <HealthCheckGuard>
        <Plans />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/devices`,
    element: (
      <HealthCheckGuard>
        <Devices />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/addons`,
    element: (
      <HealthCheckGuard>
        <Addons />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/create-plans`,
    element: (
      <HealthCheckGuard>
        <CreatePlan />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/edit-plans/:id`,
    element: (
      <HealthCheckGuard>
        <CreatePlan />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/add-device`,
    element: (
      <HealthCheckGuard>
        <AddDevice />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/edit-device/:id`,
    element: (
      <HealthCheckGuard>
        <AddDevice />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/create-addons`,
    element: (
      <HealthCheckGuard>
        <CreateAddons />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/edit-addons/:id`,
    element: (
      <HealthCheckGuard>
        <CreateAddons />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/*`,
    element: (
      <HealthCheckGuard>
        <RedirectErrorElement />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
];

//Add the unauthenticated pages
export const authItemsPaths = [
  {
    path: `/*`,
    element: <ApiLoader loading={true} />,
    isPrivateRoute: true,
  },
  {
    path: "/page-not-found",
    element: <Error />,
    isPrivateRoute: false,
  },
  {
    path: "/page-under-construction",
    element: <Error />,
    isPrivateRoute: false,
  },
];
